import { FC, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ColumnName } from '../../../../../../enum/health-monitor/ColumnName';
import { useAppSelector } from '../../../../../../hook/useAppSelector';
import { useAppDispatch } from '../../../../../../hook/useAppDispatch';
import { setColumnToSearchBy } from '../../../../../../store/slice/health-monitor/device-list';
import dropdownArrow from '../../../../../../assets/img/png/health-monitor/rows-per-page-dropdown.png';
import { useCloseOnScrollAndClickOutside } from '../../../../../../hook/useCloseOnScrollAndClickOutside';

const columnNames = [ColumnName.NAME, ColumnName.BETSHOP];

const SearchColumnDropdownPicker: FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const columnToSearchBy = useAppSelector((state) => state.deviceList.columnToSearchBy);
  const menuRef = useRef<HTMLDivElement>(null);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  useCloseOnScrollAndClickOutside(setIsOpen, menuRef);

  const translateColumnName = (columnName: ColumnName): string => {
    let resultingColumnName = '';

    switch (columnName) {
      case ColumnName.BETSHOP:
        resultingColumnName = t('healthMonitor.header.filter.column.betshop');
        break;

      default:
        resultingColumnName = t('healthMonitor.header.filter.column.name');
        break;
    }

    return resultingColumnName;
  };

  return (
    <div ref={menuRef} className="dropdown_filter_by" onClick={() => setIsOpen((prevState) => !prevState)}>
      <span>{t('healthMonitor.header.filter.searchByColumn')}</span>
      <span className="option">{translateColumnName(columnToSearchBy)}</span>
      <img className={`arrow_icon ${isOpen ? 'rotated' : ''}`} src={dropdownArrow} alt="dropdownArrow"></img>
      <ul className={`menu ${isOpen ? 'opened' : ''}`}>
        {columnNames.map((columnName) => (
          <li
            key={columnName}
            className={`${columnToSearchBy === columnName ? 'active' : ''}`}
            onClick={() => dispatch(setColumnToSearchBy(columnName))}
          >
            {translateColumnName(columnName)}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SearchColumnDropdownPicker;
